import { memo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { EditCollectionsModalActions } from "./EditCollectionsModalActions";
import { EditCollectionsModalContent } from "./EditCollectionsModalContent";
import { Modal } from "../Modal";
import { collectionAreaForPostcodeSelector } from "../../../reducers/matrixProfile/selectors";
import { collectionEditPostcodeSelector } from "../../../reducers/ownApp/selectors";
import { editCollectionTimes } from "../../../reducers/matrixProfile/thunkActions";
import { setCollectionEditPostcode } from "../../../reducers/ownApp";

export const EditCollectionsModal = memo(() => {
  const dispatch = useDispatch();
  const collectionEditPostcode = useSelector(collectionEditPostcodeSelector);
  const collection = useSelector(
    collectionAreaForPostcodeSelector(collectionEditPostcode)
  );
  const [newCollection, setNewCollection] = useState();
  const [inputError, setInputError] = useState(false);

  const onClose = () => {
    dispatch(setCollectionEditPostcode(null));
  };

  const onSave = () => {
    dispatch(editCollectionTimes({ ...collection, ...newCollection }));
  };

  const handleChange = (collection) => {
    setNewCollection(collection);
  };

  return (
    <Modal
      open={!!collectionEditPostcode}
      title={"Set Collection Times"}
      minWidth={500}
      content={
        <EditCollectionsModalContent
          collection={collection}
          handleChange={handleChange}
          handleInputError={(modalInputError) => {
            setInputError(modalInputError);
          }}
        />
      }
      actions={
        <EditCollectionsModalActions
          onCancel={onClose}
          onSave={onSave}
          inputError={inputError}
        />
      }
      onClose={onClose}
    />
  );
});
